import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ConvertDatePipe } from '../../../shared/filters/convert-date/convert-date.pipe';
import { ColorsPipe } from '@shared/filters/colors/colors.pipe';
import { ByWordPipe } from '../../../shared/filters/by-word/by-word.pipe';
import { AfTranslatePipe } from '@shared/modules/translate/pipe/af-translate.pipe';
import { AfOrderByPipe } from '@shared/filters/af-order-by/af-order-by.pipe';
import { TooltipModule } from 'primeng/tooltip';
import { NgClass } from '@angular/common';
import { SpanTooltipComponent } from '../../../shared/components/span-tooltip/span-tooltip.component';

@Component({
    selector: 'evaluation-blanqueo-row',
    templateUrl: './evaluation-blanqueo-row.component.html',
    standalone: true,
    imports: [SpanTooltipComponent, NgClass, TooltipModule, AfOrderByPipe, AfTranslatePipe, ByWordPipe, ColorsPipe, ConvertDatePipe]
})
export class EvaluationBlanqueoRowComponent {
  @Input() evaluationsListFilter: any = [];
  @Input() canCreate: boolean = false;
  @Input() view: any = '';
  @Input() client: any;
  @Input() searchEvaluation: any;
  @Input() filterTypes: any;
  @Input() filterOrder: any;
  @Input() order: any;
  @Output() emitEventRow = new EventEmitter();

  clickRow(evaluation: any, e:any=undefined){
    let action = this.view === 'deleted'?'restoreEvaluation':'editOption';
    this.emitEvent(action, evaluation, e);
  }

  emitEvent(type: any='', evaluation: any, e:any=undefined){
    this.emitEventRow.emit({
        type: type,
        evaluation: evaluation,
        event: e
    });
  }
}
